

























import { Component, Prop, Vue } from 'vue-property-decorator';
import { NetworkUptimeReport, BssUptimeReport } from '@/types';

@Component({
  components: {
    
  },
})
export default class BaseStationReport extends Vue {
  
  @Prop({ default: () => {},  type: Object}) bssReport!: BssUptimeReport;
  
  mounted() {
    
  }

  get orderedOutages():object[] {

    if(this.bssReport.outageList.length === 0)
      return [];

    return this.bssReport.outageList.sort((a,b) => a.startTs - b.startTs);
  }
  
}
